<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="qualityCheckTestSelectItems"
            v-model="item.qualityCheckTest"
            :items="qualityCheckTestSelectItems"
            :error-messages="qualityCheckTestErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.test')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="valueSelectItems"
            v-model="item.value"
            :items="valueSelectItems"
            :error-messages="valueErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.value.result')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('qualitycheck.qualitycheck.comment')"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'QualityCheckValueForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.qualityCheckTestGetSelectItems();
      this.valueGetSelectItems();
  },
  data() {
    return {
        qualityCheck: null,
        qualityCheckTest: null,
        value: null,
        comment: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_qualitychecktest ||
         this.isLoading_qualitycheckvaluetype
       );
    },
      ...mapFields('qualitychecktest', {
        qualityCheckTestSelectItems: 'selectItems',
        isLoading_qualitychecktest : 'isLoading'
      }),
      ...mapFields('qualitycheckvaluetype', {
        valueSelectItems: 'selectItems',
        isLoading_qualitycheckvaluetype : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    qualityCheckTestErrors() {
      const errors = [];

      if (!this.$v.item.qualityCheckTest.$dirty) return errors;

      has(this.violations, 'qualityCheckTest') && errors.push(this.violations.qualityCheckTest);


      return errors;
    },
    valueErrors() {
      const errors = [];

      if (!this.$v.item.value.$dirty) return errors;

      has(this.violations, 'value') && errors.push(this.violations.value);


      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

      ...mapActions({
        qualityCheckTestGetSelectItems: 'qualitychecktest/fetchSelectItems'
      }),
      ...mapActions({
        valueGetSelectItems: 'qualitycheckvaluetype/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      qualityCheckTest: {
      },
      value: {
      },
      comment: {
      },
    }
  }
};
</script>
